import { ClaimAction, ClaimActionTypes, ClaimState } from "./types";
import { getCookie } from "../../helper";

const getSavedClaimData = (): ClaimState => {
  try {
    const savedData = getCookie("ace2_claim_data");
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      return {
        claimData: parsedData,
        uploadedInvoiceUrl: parsedData?.purchase_info?.uploaded_invoice_url,
      };
    }
  } catch (e) {
    console.error("Error parsing saved claim data", e);
  }
  return {};
};

const initialState: ClaimState = getSavedClaimData();

export const claimReducer = (
  state: ClaimState = initialState,
  action: ClaimActionTypes
): ClaimState => {
  switch (action.type) {
    case ClaimAction.UPLOAD_INVOICE_SUCCESS:
      return {
        ...state,
        uploadedInvoiceUrl: action.payload.url,
      };
    case ClaimAction.RESTORE_CLAIM_DATA:
      return {
        ...state,
        claimData: action.payload,
        uploadedInvoiceUrl: action.payload?.purchase_info?.uploaded_invoice_url,
      };
    default:
      return state;
  }
};
